import { useCallback, useState } from 'react';

import { useParams } from 'react-router-dom';

import useFeatureFlags from 'api/useFeatureFlags';
import { Offer } from 'common/contracts';
import { EFeatureFlag } from 'constants/enums';

interface IUseBuyOneGetManyCheatsReturn {
  cheatsOffer: Offer | null;
  cheatsOfferId: string | null;
  hasFeatureFlagCheats: boolean;
  onOpenCheats: (offer: Offer) => void;
  handleCloseCheats: () => void;
}

/**
 * Encapsulates cheats-related state and feature flag logic
 * for the Buy One Get Many table.
 *
 * @example
 * const { cheatsOffer, cheatsOfferId, hasFeatureFlagCheats, onOpenCheats, handleCloseCheats } =
 *   useBuyOneGetManyCheats();
 */
export const useBuyOneGetManyCheats = (): IUseBuyOneGetManyCheatsReturn => {
  const { publisherId } = useParams();
  const { featureFlags } = useFeatureFlags({ publisherId });

  const [cheatsOffer, setCheatsOffer] = useState<Offer | null>(null);

  const hasFeatureFlagCheats = !!featureFlags?.[EFeatureFlag.DASHBOARD_ROLLING_CHEATS];

  const handleCloseCheats = useCallback((): void => {
    setCheatsOffer(null);
  }, []);

  const onOpenCheats = useCallback((offer: Offer): void => {
    setCheatsOffer(offer);
  }, []);

  let cheatsOfferId: string | null = null;
  if (cheatsOffer !== null && cheatsOffer.offerId !== undefined) {
    cheatsOfferId = cheatsOffer.offerId;
  }

  return {
    cheatsOffer,
    cheatsOfferId,
    hasFeatureFlagCheats,
    onOpenCheats,
    handleCloseCheats
  };
};
